const clearFloat = `
  content: '';
  display: block;
  width: 0;
  height: 0;
  clear: both;
`;

export default clearFloat;